import axios, { AxiosError } from "axios";
import { userLogin } from "../models/commonModels";
const host = `${window.location.protocol}//${window.location.hostname}/`
export const runningHttpClient = axios.create({
    //baseURL: "https://sportsrestaurant.online",
    baseURL: host,
    headers: {
        'Content-type': 'application/json'
    }
})

export default runningHttpClient;

runningHttpClient.interceptors.request.use(config => {
    // if(config.method=='options'){
    //      debugger
    //     config.headers.Authorization =  'eyJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3NTYxOTI1ODYsImlhdCI6MTc1NjE5MDc4NiwiaXNzIjoiUnVuTWlsbGlvbnMiLCJhdWQiOiJDSTM5NzkxMDRJIiwiZW1haWwiOiJwdnJ1YmluQHNiZXJiYW5rLnJ1Iiwic3ViIjoiNSIsImdyb3VwcyI6WyJST0xFX1VTRVIiXX0.u-ad7BSJi67M03fPey2UMOC5aOAIQQ0YKug_qrTSqq0';
    // }
    if(config.url?.includes("v1")){
        const token = localStorage.getItem('token');
            config.headers.Authorization = token;
    }

    if(config.url?.includes("admin")){
        const token = localStorage.getItem('token');
            config.headers.Authorization = token;
    }
  
  return config;
});

// runningHttpClient.interceptors.response.use((response) => {
//     debugger
//     if(response.status === 401) {
//          alert("You are not authorized");
//     }
//     return response;
// }, (error) => {
//     const originalRequest = error.config;
//     debugger
//     if (error.code === "ERR_NETWORK" && !originalRequest._retry) {

//     originalRequest._retry = true;

//     const refreshToken = window.localStorage.getItem('refreshToken');
//     const savedUser = localStorage.getItem("currentUser")
//             if(savedUser!=null) {
//                 const initialValue:userLogin = JSON.parse(savedUser)
//                 if(initialValue==null||initialValue.email?.length==0||initialValue.pswd?.length==0){

//                 }else{async error => {
//                     debugger
//                     const res = await axios.post('https://sportsrestaurant.online/login', { initialValue })
//                     return axios.post('https://sportsrestaurant.online/login', { initialValue })
//                     .then(({data}) => {
//                         debugger
//                         localStorage.setItem('token',data.token)
//                         axios.defaults.headers.common['Authorization'] = data.token;
//                         originalRequest.headers['Authorization'] = data.token;
//                         return axios(originalRequest);
//                         });
//                 }

//             }
//   }
//     return Promise.reject(error.message);
// });

// runningHttpClient.interceptors.response.use((response) => {
//     debugger
//     if(response.status === 401) {
//          alert("You are not authorized");
//     }
//     return response;
// }, 
//     async (error) => {        
//         debugger 
//         const err:AxiosError =   error as AxiosError             
//         const originalRequest = error.config;
//         const status = err.response?.status;
//         if (error.code === "ERR_NETWORK" && !originalRequest._retry) {
//             originalRequest.isRetry = true;
//             try {
//                 const savedUser = localStorage.getItem("currentUser")
//                 if(savedUser!=null) {
//                     const initialValue:userLogin = JSON.parse(savedUser)
//                     if(initialValue==null||initialValue.email?.length==0||initialValue.pswd?.length==0){
//                     }else{
//                         const res = await axios.post('https://sportsrestaurant.online/login',  initialValue )
//                         if(res.status===200){
//                             localStorage.setItem('token',res.data.token)
//                             //axios.defaults.headers.common['Authorization'] = res.data.token;
//                             originalRequest.headers['Authorization'] = res.data.token;
//                             return axios(originalRequest);
//                         }
//                     }
//                 }
//                 //return axios(originalRequest);
//             } catch (e) {
//                 console.log('refreshToken request - error', e)
//             }
//         }
//         //if (error.response.status === 503) return
//         return Promise.reject(error.response.data);
//     });
